<template>
  <div class="fixedflexcn loginbg paddinglogin" :style="{backgroundImage: `url(${WebSetting.bgpicture})`}">
    <div class="row m-0 incontainerlg">
      <div class="col-md-5 col-lg-6 d-none d-md-flex p-0 flexcn">
        <div class="leftcartoon animate__animated animate__zoomInDown">
          <img :src="WebSetting.banner" />
        </div>
      </div>
      <div class="col-12 col-md-7 col-lg-6 p-0 px-1 px-md-2 px-lg-4 flexcn">
        <div class="bginputlogin" :style="{ backgroundImage: createBackgroundString }">
          <img class="ic-lg-01" src="./../assets/icon/06.png" />
          <img class="ic-lg-02" src="./../assets/icon/02.png" />
          <div class="logologin">
            <img :src="WebSetting.logo" />
          </div>
          <div class="inbgbeforelogin">
            <div>
              <div class="headerlogin">
                <h2>สมัครสมาชิก</h2>
              </div>
              <div class="stepregister">
                <div class="stepregis step01 active" v-if="state == 1">1</div>
                <div class="stepregis step01" v-if="state != 1" disabled>1</div>
                <div class="stepregis step02 active" v-if="state == 2">2</div>
                <div class="stepregis step02" v-if="state != 2" disabled>2</div>
                <div class="stepregis step03 active" v-if="state == 3">3</div>
                <div class="stepregis step03" v-if="state != 3" disabled>3</div>
                <div class="stepregis step05"><i class="far fa-check"></i></div>
              </div>
              <!-- --------------------------------step1-------------------------------- -->
              <div class="re01" v-if="state == 1">
                <div class="form-group">
                  <div>
                    <label>กรอกเบอร์โทรศัพท์</label>
                    <div class="el-input my-1">
                      <i class="-icon fas fa-phone"></i>
                      <input
                        type="text"
                        class="inputstyle"
                        :placeholder="
                          BankSelect === 'truewallet'
                            ? 'กรอกเบอร์โทรศัพท์ทรูมันนี่วอลเล็ท'
                            : 'กรอกเบอร์โทรศัพท์'
                        "
                        autofocus="autofocus"
                        autocomplete="on"
                        inputmode="numeric"
                        v-model="Form.phone"
                        maxlength="10"
                        size="10"
                        onkeypress="return event.charCode != 32"
                        oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1');"
                      />
                    </div>
                    <span class="text-danger" v-if="chkPhone">
                      {{ msgErr }}</span
                    >
                  </div>
                </div>
                <div class="form-group">
                  <div>
                    <label>รหัสผ่าน</label>
                    <div class="el-input my-1">
                      <i class="fas fa-lock"></i>
                      <input
                        type="password"
                        v-model="Form.password"
                        placeholder="รหัสผ่าน"
                        class="inputstyle"
                      />
                    </div>
                  </div>
                  <div
                    v-if="
                      Form.password !== '' &&
                      Form.con_password !== '' &&
                      Form.password != Form.con_password
                    "
                    style="color: red; font-size: 0.7rem; margin-left: 5px"
                  >
                    <label>รหัสผ่านไม่ตรงกัน</label>
                    <div class="el-input my-1"></div>
                  </div>
                </div>
                <div class="form-group">
                  <div>
                    <label>ยืนยันรหัสผ่าน</label>
                    <div class="el-input my-1">
                      <i class="fas fa-lock"></i>
                      <input
                        type="password"
                        v-model="Form.con_password"
                        placeholder="รหัสผ่าน"
                        class="inputstyle"
                      />
                    </div>
                  </div>
                  <div
                    v-if="
                      Form.password !== '' &&
                      Form.con_password !== '' &&
                      Form.password != Form.con_password
                    "
                    style="color: red; font-size: 0.7rem; margin-left: 5px"
                  >
                    <label>รหัสผ่านไม่ตรงกัน</label>
                    <div class="el-input my-1"></div>
                  </div>
                </div>
                <div class="form-group form-check text-center">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    id="term_check"
                    v-model="term_check"
                    style="cursor: pointer"
                  />
                  <label class="form-check-label" for="term"
                    >ยอมรับเงื่อนไข</label
                  >
                  <a
                    class="text-primary"
                    id="condition"
                    style="cursor: pointer"
                    @click="openTermModal"
                    >Term & Condition</a
                  >
                </div>
                <button
                  type="submit"
                  class="loginbtn"
                  :disabled="
                    !term_check ||
                    Form.phone == '' ||
                    Form.phone.length != 10 ||
                    Form.password === '' ||
                    Form.con_password === '' ||
                    Form.password != Form.con_password
                  "
                  @click="checkPhone"
                >
                  ถัดไป
                </button>
              </div>
              <!-- --------------------------------step1-------------------------------- -->
              <!-- --------------------------------step2-------------------------------- -->

              <div class="re02" v-if="state == 2">
                <div class="form-group">
                  <div>
                    <label>ท่านต้องการใช้ธนาคาร หรือ ทรูมันนี่วอลเล็ท</label>
                    <div class="el-input my-1">
                      <i class="fad fa-university"></i>
                      <select class="inputstyle" v-model="BankSelect">
                        <option selected value="">-- เลือก --</option>
                        <option value="bank">ธนาคาร</option>
                        <option value="truewallet">ทรูมันนี่วอลเล็ท</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div
                  class="form-group"
                  id="s_bank_form"
                  v-if="BankSelect === 'bank'"
                >
                  <div>
                    <label>เลือกธนาคาร</label>
                    <div class="el-input my-1">
                      <i class="fad fa-university"></i>
                      <select class="inputstyle" v-model="Form.bank">
                        <option selected value="">-- เลือกธนาคาร --</option>
                        <option value="กรุงเทพ">
                          ธนาคารกรุงเทพ จำกัด (มหาชน)
                        </option>
                        <option value="กสิกรไทย">
                          ธนาคารกสิกรไทย จำกัด (มหาชน)
                        </option>
                        <option value="กรุงไทย">
                          ธนาคารกรุงไทย จำกัด (มหาชน)
                        </option>
                        <option value="ทหารไทยธนชาต">
                          ธนาคารทหารไทยธนชาต จำกัด (มหาชน)
                        </option>
                        <option value="ไทยพาณิชย์">
                          ธนาคารไทยพาณิชย์ จำกัด (มหาชน)
                        </option>
                        <option value="ซิตี้แบงค์">
                          ธนาคารซิตี้แบงก์ เอ็น.เอ.
                        </option>
                        <option value="แสตนดาร์ดชาร์เตอร์">
                          ธนาคารสแตนดาร์ดชาร์เตอร์ด (ไทย) จำกัด (มหาชน)
                        </option>
                        <option value="ซีไอเอ็มบีไทย">
                          ธนาคารซีไอเอ็มบี ไทย จำกัด (มหาชน)
                        </option>
                        <option value="ยูโอบี">
                          ธนาคารยูโอบี จำกัด (มหาชน)
                        </option>
                        <option value="กรุงศรีฯ">
                          ธนาคารกรุงศรีอยุธยา จำกัด (มหาชน)
                        </option>
                        <option value="ออมสิน">ธนาคารออมสิน</option>
                        <option value="ธอส">ธนาคารอาคารสงเคราะห์</option>
                        <option value="ธกส">
                          ธนาคารเพื่อการเกษตรและสหกรณ์การเกษตร
                        </option>
                        <option value="อิสลาม">
                          ธนาคารอิสลามแห่งประเทศไทย
                        </option>
                        <option value="ทิสโก้">
                          ธนาคารทิสโก้ จำกัด (มหาชน)
                        </option>
                        <option value="เกียรตินาคินภัทร">
                          ธนาคารเกียรตินาคินภัทร จำกัด (มหาชน)
                        </option>
                        <option value="ไอซีบีซี">
                          ธนาคารไอซีบีซี (ไทย) จำกัด (มหาชน)
                        </option>
                        <option value="ไทยเครดิต">
                          ธนาคารไทยเครดิต เพื่อรายย่อย จำกัด (มหาชน)
                        </option>
                        <option value="LHBANK">
                          ธนาคารแลนด์ แอนด์ เฮ้าส์ จำกัด (มหาชน)
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="form-group" v-if="BankSelect === 'bank'">
                  <div>
                    <label>เลขบัญชีธนาคาร</label>
                    <div class="el-input my-1">
                      <i class="fas fa-lock"></i>
                      <input
                        type="text"
                        placeholder="เลขบัญชีธนาคาร"
                        autofocus="autofocus"
                        autocomplete="on"
                        inputmode="numeric"
                        v-model="Form.bank_number"
                        onkeypress="return event.charCode != 32"
                        oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1');"
                        class="inputstyle"
                      />
                    </div>
                    <span class="text-danger" v-if="chkBank">
                      {{ msgErrBank }}</span
                    >
                  </div>
                </div>
                <div class="form-group" v-if="BankSelect === 'truewallet'">
                  <div>
                    <label>เบอร์ทรูมันนี่วอลเล็ท</label>
                    <div class="el-input my-1">
                      <i class="fas fa-lock"></i>
                      <input
                        type="text"
                        placeholder="เบอร์ทรูมันนี่วอลเล็ท"
                        autofocus="autofocus"
                        autocomplete="on"
                        maxlength="10"
                        size="10"
                        inputmode="numeric"
                        v-model="Form.phone"
                        onkeypress="return event.charCode != 32"
                        oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1');"
                        class="inputstyle"
                        disabled
                      />
                    </div>
                  </div>
                </div>
                <button type="submit" class="loginbtn" @click="state = 1">
                  ย้อนกลับ
                </button>
                <button
                  type="submit"
                  class="loginbtn"
                  :disabled="!Form.bank_number"
                  @click="checkBank"
                  v-if="BankSelect == 'bank'"
                >
                  ถัดไป
                </button>
                <button
                  type="submit"
                  class="loginbtn"
                  :disabled="!Form.phone"
                  @click="checkBank"
                  v-else-if="BankSelect == 'truewallet'"
                >
                  ถัดไป
                </button>
                <button type="submit" class="loginbtn" disabled v-else>
                  ถัดไป
                </button>
              </div>
              <!-- --------------------------------step2-------------------------------- -->
              <!-- --------------------------------step3-------------------------------- -->
              <div class="re03" v-if="state == 3">
                <div class="form-group">
                  <div>
                    <label>ชื่อ</label>
                    <div class="el-input my-1">
                      <i class="fas fa-user"></i>
                      <input
                        type="text"
                        v-model="Form.fname"
                        placeholder="ชื่อ"
                        class="inputstyle"
                      />
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <div>
                    <label>นามสกุล</label>
                    <div class="el-input my-1">
                      <i class="fas fa-user"></i>
                      <input
                        type="text"
                        v-model="Form.lname"
                        placeholder="นามสกุล"
                        class="inputstyle"
                      />
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <div>
                    <label>ไอดีไลน์</label>
                    <div class="el-input my-1">
                      <i class="fas fa-user"></i>
                      <input
                        type="text"
                        v-model="Form.line_id"
                        placeholder="ไอดีไลน์"
                        class="inputstyle"
                      />
                    </div>
                  </div>
                </div>
                <button type="submit" class="loginbtn" @click="state = 2">
                  ย้อนกลับ
                </button>
                <button
                  type="button"
                  class="loginbtn"
                  @click="onClickRegister"
                  :disabled="Form.fname == '' || Form.lname == ''"
                  id="regis"
                >
                  สมัครสมาชิก
                </button>
              </div>
              <!-- --------------------------------step3-------------------------------- -->
              <div class="re04 finishcontain" v-if="state == 4">
                สมัครสำเร็จโปรดรอสักครู่..
              </div>
              <div
                class="wantregister"
                id="s_bank_form"
                v-if="refphone !== true"
              >
                <div class="wantregister">
                  มีบัญชีผู้ใช้อยู่แล้ว?
                  <router-link class="text-primary" to="login"
                    ><u>เข้าสู่ระบบเลย</u></router-link
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <TermModal ref="termmodal" />
  </div>

  <!-- <footer class="footer mt-auto py-3">
    <div class="container">Place sticky footer content here.</div>
  </footer>

  <div class="sideline" onclick="location.href='-'">
    <i class="fab fa-line"></i>
    <br />ติดต่อเรา
  </div> -->
</template>

<script>
import { HTTP } from "@/services/http-common";
import TermModal from "@/components/modal/TermModal.vue";
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["WebSetting"]),
    createBackgroundString() {
      return `linear-gradient(348deg, #000000, ${this.primaryColor}), linear-gradient(180deg, #a78059 -30%, #f2d7a9 22%, #715236 72%, #f1bb73 112%)`;
    },
  },
  name: "RegisterModal",
  mounted() {
    let uri = window.location.search.substring(1);
    let params = new URLSearchParams(uri);
    let ref = "";
    //   if (params.has("ref")) {
    //     ref = params.get("ref")
    //     console.log(ref);
    //   }
    // },
    if (params.has("ref")) {
      ref = params.get("ref");
      if (ref.length == 10) {
        this.refphone = true;
      }
    }
  },
  components: { TermModal },
  directives: {},
  data() {
    return {
      windowWidth: window.innerWidth,
      checkTmnId: false,
      BankSelect: "",
      select: "",
      registerModal: false,
      term_check: false,
      refphone: false,
      state: 1,
      affRef: false,
      tempURL:"../img/10.jpg",
      primaryColor:"#001c4d",
      Form: {
        phone: "",
        fname: "",
        lname: "",
        bank: "",
        bank_number: "",
        password: "",
        con_password: "",
        tmnId: "",
        affPhone: "",
        line_id:"",
      },
      FormLogin: {
        phone: "",
        password: "",
      },
      chkPhone: false,
      chkBank: false,
      msgErr: "",
      msgErrBank: "",
    };
  },
  created() {
    this.fetchWebSetting();
  },
  methods: {
    openTermModal() {
      this.$refs.termmodal.show();
    },
    fetchWebSetting() {
      HTTP.get(`system/info`)
        .then((resp) => {
          this.$store.dispatch("savePageSetting", resp.data.data);
          if(resp.data.data != null && resp.data.data.color1 != null)
          {
            this.primaryColor = resp.data.data.color1;
          }          
        })
        .catch((err) => {
          this.$toast.error(
            err.data.msg != undefined
              ? err.data.msg
              : "ไม่สามารถโหลดได้ กรุณาลองใหม่"
          );
        });
    },
    onClickLogin() {
      if (!isNaN(this.FormLogin.phone)) {
        if (this.FormLogin.phone.length == 10) {
          HTTP.post(`member/login`, {
            phone: this.FormLogin.phone,
            password: this.FormLogin.password,
          })
            .then((resp) => {
              if (resp.data.status != undefined && !resp.data.status) {
                this.$toast.error(
                  resp.data.msg != undefined
                    ? resp.data.msg
                    : "ไม่สามารถเข้าสู่ระบบได้ กรุณาลองใหม่"
                );
              } else {
                if (resp.data.status != undefined && resp.data.status) {
                  this.$store.dispatch("loginAuth", resp.data);
                  this.$router.push("/");
                  // window.location.reload();
                }
              }
            })
            .catch((err) => {
              if (err.response) {
                this.$toast.error(
                  err.response.data.msg != undefined
                    ? err.response.data.msg
                    : "ไม่สามารถเข้าสู่ระบบได้ กรุณาลองใหม่"
                );
              }
            });
        } else {
          this.$toast.error("เบอร์โทรศัพท์ต้องเป็นตัวเลข 10 หลักเท่านั้น");
        }
      } else {
        this.$toast.error("เบอร์โทรศัพท์ต้องเป็นตัวเลขเท่านั้น");
      }
    },
    onClickRegister() {
      let bank = "";
      let wallet = this.Form.phone;
      if (this.BankSelect === "bank") {
        bank = this.Form.bank_number;
      }
      //  else {
      //   wallet = this.Form.phone;
      // }
      document.getElementById("regis").disabled = true;
      let bankName =
        this.BankSelect === "truewallet" ? "truewallet" : this.Form.bank;

      if (this.BankSelect === "truewallet" && this.Form.tmnId === "") {
        this.Form.tmnId = this.Form.phone;
      }

      // HTTP.get("https://www.cloudflare.com/cdn-cgi/trace", {
      //   responseType: "text",
      // })
      //   .then((resp) => {
      //     let respArr = resp.data
      //       .trim()
      //       .split("\n")
      //       .map((line) => line.split("="));
      //     let ip = respArr[2][1];
      let uri = window.location.search.substring(1);
      let params = new URLSearchParams(uri);
      let ref = "";
      if (params.has("ref")) {
        ref = params.get("ref");
      }
      HTTP.post(`member/register`, {
        phone: this.Form.phone,
        password: this.Form.password,
        fname: this.Form.fname,
        lname: this.Form.lname,
        bank_number: bank,
        bank_name: bankName,
        tmn_id: wallet,
        aff: ref,
        ip: "",
        line_id:this.Form.line_id,
      })
        .then((resp) => {
          if (resp.data.status != undefined && !resp.data.status) {
            document.getElementById("regis").disabled = false;
            this.$toast.error(
              resp.data.msg != undefined
                ? resp.data.msg
                : "ไม่สามารถสมัครสมาชิกได้ กรุณาลองใหม่"
            );
          } else {
            this.$toast.success(
              resp.data.msg != undefined ? resp.data.msg : "สมัครสมาชิกสำเร็จ"
            );
            this.FormLogin.phone = this.Form.phone;
            this.FormLogin.password = this.Form.password;
            localStorage.removeItem("ref");
            this.onClickLogin();
            this.clearRegisterForm();
            this.state = 4;
          }
        })
        .catch((err) => {
          document.getElementById("regis").disabled = false;
          this.$toast.error(
            err.data.msg != undefined
              ? err.data.msg
              : "ไม่สามารถสมัครสมาชิกได้ กรุณาลองใหม่"
          );
        });
      // })
      // .catch(() => {
      //   document.getElementById("regis").disabled = false;
      //   this.$toast.error("ไม่สามารถทำรายการได้ กรุณาลองใหม่");
      // });
    },
    checkStep() {
      this.state = 2;
    },
    checkPhone() {
      if (this.Form.phone.charAt(0) == "0") {
        if (!isNaN(this.Form.phone)) {
          // if (this.BankSelect === "truewallet" && !this.checkTmnId) {
          //   this.state = 3;
          // } else {
          HTTP.post(`member/checkphone`, {
            phone: this.Form.phone,
          })
            .then((resp) => {
              if (resp.data.status) {
                this.state = 2;
                this.chkPhone = false;
              }
            })
            .catch((err) => {
              // this.$toast.error(
              //   err.data.msg != undefined
              //     ? err.data.msg
              //     : "ไม่สามารถทำรายการได้ กรุณาลองใหม่"
              // );
              if (err.data.status == false) {
                this.chkPhone = true;
                this.msgErr = err.data.msg;
              }
            });
          // }
        } else {
          this.$toast.error("เบอร์โทรศัพท์ต้องเป็นตัวเลขเท่านั้น");
        }
      } else {
        this.$toast.error("กรุณากรอกเบอร์โทรศัพท์ให้ถูกต้อง");
      }
    },
    checkBank() {
      let bankNumber =
        this.BankSelect === "truewallet"
          ? this.Form.tmnId
          : this.Form.bank_number;

      let CheckNumber;
      if (this.BankSelect === "truewallet") {
        CheckNumber = true;
      } else {
        if (!isNaN(bankNumber)) {
          CheckNumber = true;
        } else {
          CheckNumber = false;
        }
      }

      if (this.BankSelect === "truewallet" && !this.checkTmnId) {
        this.state = 3;
      } else {
        if (CheckNumber) {
          if (bankNumber.length == 10 || bankNumber.length == 12) {
            HTTP.post(`member/checkbank`, {
              bank_number: bankNumber,
            })
              .then((resp) => {
                if (resp.data.status != undefined && !resp.data.status) {
                  this.$toast.error(
                    resp.data.msg != undefined
                      ? resp.data.msg
                      : "ไม่สามารถทำรายการได้ กรุณาลองใหม่"
                  );
                } else {
                  this.state = 3;
                  this.chkBank = false;
                }
              })
              .catch((err) => {
                // this.$toast.error(
                //   err.data.msg != undefined
                //     ? err.data.msg
                //     : "ไม่สามารถทำรายการได้ กรุณาลองใหม่"
                // );
                if (err.data.status == false) {
                  this.chkBank = true;
                  this.msgErrBank = err.data.msg;
                }
              });
          } else {
            this.$toast.error("เลขบัญชีต้องมี 10 หรือ 12 ตัวเท่านั้น");
          }
        } else {
          this.$toast.error("ข้อมูลต้องเป็นตัวเลขเท่านั้น");
        }
      }
    },
    changeMenu(menu) {
      if (menu === "login") {
        this.select = "login";
      } else {
        this.clearRegisterForm();
        this.select = "register";
      }
    },
    clearRegisterForm() {
      this.Form.phone = "";
      this.Form.fname = "";
      this.Form.lname = "";
      this.Form.line_id = "";
      this.Form.bank = "";
      this.Form.bank_number = "";
      this.Form.password = "";
      this.Form.con_password = "";
      this.Form.tmnId = "";
      this.Form.affPhone = "";
      this.term_check = false;
      this.BankSelect = "";
      this.checkTmnId = false;
      this.affRef = false;
      this.state = 1;
    },
    clearLoginForm() {
      this.FormLogin.phone = "";
      this.FormLogin.password = "";
    },
    show(select) {
      let ref = localStorage.getItem("ref");
      if (ref != null) {
        this.Form.affPhone = ref;
        this.affRef = true;
      }
      this.select = select;
      this.registerModal = true;
    },
    hide() {
      this.registerModal = false;
      this.$refs.termmodal.show();
    },
  },
  
};
</script>

<style></style>
